import React from "react";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// components
import UnauthMenu from "./UnauthMenu";
import AuthMenu from "./Auth/AuthMenu";

// component
const User = () => {
    const { isLoggedIn, isLoading } = useSiteHeader();

    if (isLoading) return null;

    return isLoggedIn ? <AuthMenu /> : <UnauthMenu />;
};

export default User;
